/**
 * 根据提货类型 渲染表单
 * 且会在 第二步数据返回才显示
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2023, all rights reserved. Essa.cn
 *
 * @param deliveryOrderId 编辑时传入此id,等同于将以有否 deliveryOrderId 判断是否编辑状态
 **/
import React from "react";
import {Modal, Alert,Button,Checkbox,Input} from 'antd';
import FormFormat from '@/components/FormFormat/FormFormat';
import dayjs from "dayjs";
import Lang from "@components/Lang/Lang";
import LogisticsCompanyList from "./logisticsCompanyList/logisticsCompanyList";
import AddressForm from "./addressForm"
// import ConsigneeList from "./consigneeList";
import './stepSecond.less'
import moment from "moment";

const { TextArea } = Input;
export default class StepSecondForm extends React.Component{
    static propTypes = {
    }
    static defaultProps = {
        type: "", //提货类型
        logisticsCompanyList: [], //物流列表
        woodenPalletsPriceAndSymbol:"",// 打木架费用，如 XX 卢布
        currencySymbol:"",//对应货币
        transitCityName:"",//中转城市
    };
    constructor(props) {
        super(props);
        const fromInitialValues = props.fromInitialValues||{}
        this.state = {
            mapErr:false, //无法加载地图组件
            packageType: fromInitialValues.hasWoodenPallets, //  配送-是否需要打木架	number	0:不需要 1需要
            sendCheck:  fromInitialValues.hasDeliveryService==1?true:false,  // 是否需要送货服务0:不需要 1需要
            logisticsCompanyId:fromInitialValues.logisticsCompanyId||"", // 配送-物流公司id
            packageRemark:fromInitialValues.packageRemark||"",
            fieldList:[
                {
                    type:'OnlyRender',// 前往提货时间标题
                    onlyRender:(<>
                        <p className={"black66 font_14"}>{Lang({id:"ZiJiDaoCangKuTiHuoMianFei",default:"自己到仓库提货，免费！"})}</p>
                        <p className={"black89 fw_700 font_16 mt_16 mb_4"}>
                            <span className={"color-danger mr_2"}>*</span>
                            {Lang({id:"QianWangTiHuoShiJian",default:"前往提货时间"})}
                        </p>
                        {/* 免费停仓至 2023-7-1  */}
                        {fromInitialValues.freeEndDate?<p className={"black66 font_14 mb_4"}>
                            {Lang({id:"MianFeiTingCangZhi",default:"免费停仓至"})}
                            <span className={"ml_4"}>
                                {dayjs(fromInitialValues.freeEndDate).format('YYYY-MM-DD')}
                            </span>
                        </p>:null}
                    </>)
                },
                {
                    name:'preDeliveryDate',  // 前往提货时间
                    required: true,
                    type:'Date',
                    disabledDate: this.disabledDate.bind(this),
                    disabled:props.deliveryOrderId?true:false, //编辑状态不可修改时间
                },
                {
                    type:'OnlyRender', // 联系方式标题
                    onlyRender:<p className={"black89 fw_700 font_16 mt_20 mb_12"}>{Lang({id:"LianXiFangShi",default:"联系方式"})}</p>
                },
                {
                    name:'contactName',  // 联系人姓名
                    cnTitleId:'LianXiRenXingMing',
                    cnTitle:"联系人姓名",
                    required: true,
                },
                {
                    name:'contactMobile',  // 联系电话
                    nameTelephoneCode:"contactTelCode",
                    cnTitleId:'LianXiDianHua',
                    cnTitle:"联系电话",
                    required: true,
                    type:'AreaPhone',
                },
                {
                    name:'carNumber',  // 车牌号码
                    cnTitleId:'ChePaiHaoMa',
                    cnTitle:"车牌号码",
                },

            ],
            fieldList2:[
                {
                    type:'OnlyRender',
                    onlyRender:(<>
                        {/*  */}
                        <p className={"black66 font_14"}>
                            {Lang({id:"ZiJiLianXiDiSanFangWuLiuGongSiDaoCangKuTiHuo",default:"自己联系第三方物流公司到仓库提货。"})}
                        </p>
                        <p className={"black89 fw_700 font_16 mt_16 mb_2"}>
                            <span className={"color-danger mr_2"}>*</span>
                            {Lang({id:"QianWangTiHuoShiJian",default:"前往提货时间"})}
                        </p>
                        {/* 免费停仓至 2023-7-1  */}
                        {fromInitialValues.freeEndDate?<p className={"black66 font_14 mb_4"}>
                            {Lang({id:"MianFeiTingCangZhi",default:"免费停仓至"})}
                            <span className={"ml_4"}>
                                {moment(fromInitialValues.freeEndDate).format('YYYY-MM-DD')}
                            </span>
                        </p>:null}
                    </>)
                },
                {
                    name:'preDeliveryDate',  // 前往提货时间
                    required: true,
                    type:'Date',
                    disabledDate: this.disabledDate.bind(this),
                    disabled:props.deliveryOrderId?true:false, //编辑状态不可修改时间
                },
                {
                    type:'OnlyRender', // 物流公司信息 标题
                    onlyRender:<p className={"black89 fw_700 font_16 mt_20 mb_12"}>
                        {Lang({id:"WuLiuGongSiXinXi",default:"物流公司信息"})}
                    </p>
                },
                {
                    name:'logisticsCompanyName',  // 物流公司名字
                    cnTitleId:'WuLiuGongSiMingZi',
                    cnTitle:"物流公司名字",
                    required: true,
                },
                {
                    name:'logisticsNumber',  // 物流单号
                    cnTitleId:'WuLiuDanHao',
                    cnTitle:"物流单号",
                },
                {
                    type:'OnlyRender', //
                    onlyRender:(<>
                        <p className={"black89 fw_700 font_16 mt_4"}>
                            {Lang({id:"LianXiRenXinXi",default:"联系人信息"})}
                        </p>
                        <p className={"black45 font_14 mb_12"}>
                            {Lang({id:"WuLiuGongSiLianXiBuShangKeYiLianXiYiXiaRenYuan",default:"物流公司联系不上可以联系以下人员"})}
                        </p>
                    </>)
                },
                {
                    name:'contactName',  // 联系人姓名
                    cnTitleId:'LianXiRenXingMing',
                    cnTitle:"联系人姓名",
                    required: true,
                },
                {
                    name:'contactMobile',  // 联系电话
                    nameTelephoneCode:"contactTelCode",
                    cnTitleId:'LianXiDianHua',
                    required: true,
                    type:'AreaPhone',
                },
            ],
            fieldList3:[
                {
                    type:'OnlyRender',
                    onlyRender:(<>
                        {/* 物流发出日期 */}
                        <p className={"black89 fw_700 font_16 mt_16 mb_2"}>
                            <span className={"color-danger mr_2"}>*</span>
                            {Lang({id:"WuLiuFaChuRiQi",default:"物流发出日期"})}
                        </p>
                        {/*  仓库工作时间 周一 至 周五，9:00 - 18:00 */}
                        {/*<p className={"black45 font_14 mb_4"}>*/}
                            {/*{__getServerLanguage("CangKuGongZuoShiJian")}*/}
                            {/*{props.warehouseManageVO?<span className={"ml_4"}>{props.warehouseManageVO.workStartTime} - {props.warehouseManageVO.workEndTime}</span>:null}*/}
                        {/*</p>*/}
                        {/* 免费停仓至 2023-7-1  */}
                        {fromInitialValues.freeEndDate?<p className={"black66 font_14 mb_4"}>
                            {Lang({id:"MianFeiTingCangZhi",default:"免费停仓至"})}
                            <span className={"ml_4"}>
                                {moment(fromInitialValues.freeEndDate).format('YYYY-MM-DD')}
                            </span>
                        </p>:null}
                    </>)
                },
                {
                    name:'preDeliveryDate',  // 前往提货时间
                    required: true,
                    type:'Date',
                    disabledDate: this.disabledDate.bind(this),
                    disabled:props.deliveryOrderId?true:false, //编辑状态不可修改时间
                },
            ],
            visibleAgreement: false, // 协议  窗口
        }
    }
    // 渲染方式
    renderType(value,currentType,title,subTitle=""){
        const { packageRemark } = this.state;
        return (<div className={`selectBox${currentType==value?" on":""}`}
                     onClick={()=>this.onChangeType(value)}>
            <div className={"fw_500"}>{title}</div>
            {subTitle&&<p className={"font_14 black45"}>{subTitle}</p>}
            {value==1&&<div className={"mt_12 mb_16"}>
                {/* 打包要求 */}
                <p className={"color-black font_14"}>
                    {Lang({id:"DaBaoYaoQiu",default:"打包要求"})}
                </p>
                <TextArea showCount
                    // style={{ height: 120, marginBottom: 24 }}
                          placeholder={Lang({id:"QinShuRuDaBaoYaoQiu",default:"请输入打包要求"})}
                          autoSize={{ minRows: 2, maxRows: 6 }}
                          maxLength={1024}
                          value={packageRemark}
                          onChange={(e)=>this.setState({
                              packageRemark:e.target.value
                          })}  />
            </div>}
        </div>)
    }
    /**
     * 賦值
     * **/
    onChangeType(data){
        if(data=="0"){
            this.openAgreement(true,"edit");
        }else {
            this.setState({
                packageType: data
            });
        }
    }
    onRefForm = (ref) =>  this.onRefFormFormat = ref;
    onRefConsignee  = (ref) =>  this.onRefChildConsignee = ref;
    /**
     * 打开协议
     * */
    openAgreement(flag=false,type=""){
        this.setState({
            visibleAgreement: flag,
            visibleAgreementType:type
        });
    }
    handleAgreementOk(flag){
        if(flag){ // 同意即响应事件
            this.setState({
                packageType: "0"
            });
        }else {
            if(this.state.packageType=="0"){
                this.setState({
                    packageType: ""
                });
            }
        }
        this.openAgreement();//关闭
    }
    // 勾选 使用送货服务
    onChangeSend(flag=false) {
        this.setState({
            sendCheck: flag
        })
    }
    /**
     * 点击确认时 获取表单数据
     ***/
    async save(){
        const res = await this.onRefFormFormat.handleOK();
        const { type } = this.props;
        let objConsignee = {success:true,data:{}};
        if(type=="30"&&this.onRefChildConsignee){ // 合作物流 收货人信息 改为填写表单不再使用系统地址
            objConsignee = await this.onRefChildConsignee.save()||{}
        }
        if(res&&res.success&&objConsignee.success){
            const { logisticsCompanyId,sendCheck,packageType,packageRemark } = this.state;
            // let consigneeId =""
            // if(this.onRefChildConsignee){ // 收货人信息
            //    const objConsignee = this.onRefChildConsignee.save()||{}
            //    if(objConsignee&&objConsignee.id){
            //        consigneeId = objConsignee.id
            //    }
            // }
            const data = {
                ...res.data,
                ...objConsignee.data,
                hasDeliveryService:sendCheck?1:0, // 是否需要送货服务0:不需要 1需要
                hasWoodenPallets: packageType?Number(packageType):"",//	配送-是否需要打木架 0:不需要 1需要
                packageRemark,
                logisticsCompanyId,
                // consigneeId
            }
           return data
        }
    }
    /**
     * 点击物流
     * */
    onClickLogistics(item={}){
        this.setState({
            logisticsCompanyId:item.id
        })
    }
    /*
   * 配置不可选择日期  周六日禁用
   * 提货日期  大于入库时间 and 大于今天
   * */
    disabledDate(current) {
        const isoWeekday = new Date(current).getDay();
        if(isoWeekday==0||isoWeekday==6) return true;
        const fromInitialValues = this.props.fromInitialValues||{}
        const tStorageDate = fromInitialValues.inStorageDate||0; //  1695830400000;//2023-09-28
        // const tToday = moment().subtract(1, 'days').endOf('day').valueOf();//大于昨天(即大于等于今天)
        const tToday = moment().endOf('day').valueOf();//大于今天
        const sTime = tStorageDate > tToday? tStorageDate :tToday;
        return  current && current < moment(sTime).endOf('day');
    }
    componentDidMount() {
        if( this.props.onRef)this.props.onRef(this);
    };
    render() {
        const { logisticsCompanyList,woodenPalletsPriceAndSymbol,currencySymbol,
            transitCityCode, // 中转城市编码
            countryName, // 服务国家名称
            countryCode, // 服务国家编码
            fromInitialValues,transitCityName,
            type,
            // consigneeList
             } = this.props;
        const { sendCheck, fieldList,visibleAgreement,visibleAgreementType, packageType,fieldList2,fieldList3, logisticsCompanyId,} = this.state;

        return (<div className={"formWrap"}>
            {/* 方式1 -------------------------------------*/}
            {/*   普通 表单  */}
           {(type=="10"||type=="20")&&<FormFormat onRef={this.onRefForm}
                       options={type=="10"?fieldList:fieldList2}
                       formItemLayout={null}
                       formLayout = "vertical"
                       initialValues={fromInitialValues} />}

            {type=="30"&&<>
                <p>
                    {Lang({id:"ShiYongPingTaiZhiDingDeWuLiuGongSi",default:"使用平台指定的物流公司，可以享受送货服务，省钱！"})}
                </p>
                {/*  */}
                <p className={"mt_20 black89 fw_700 mb_4"}>
                    {Lang({id:"TianXieLianXiXinXi",default:"填写联系信息"})}
                </p>
                <AddressForm onRef={this.onRefConsignee} fromInitialValues={fromInitialValues} edit={false}/>
                {/* 选择物流公司 */}
                <p className={"mt_20 black89 fw_700 mb_4"}><span className={"color-danger mr_2"}>*</span>
                    {Lang({id:"XuanZeWuLiuGongSi",default:"选择物流公司"})}
                </p>
                {/*  */}
                <p className={"font_14 black45"}>
                    {Lang({id:"ZuiZhongYiWuLiuGongiShouFeiWeiZhun",default:"价格仅供参考，最终以物流公司收费为准"})}
                </p>
                {/* 物流 公司 */}
                {logisticsCompanyList&&logisticsCompanyList.length>0&&<LogisticsCompanyList logisticsCompanyList={logisticsCompanyList}
                                                                                            canClick={true}
                                                                                            logisticsCompanyId={logisticsCompanyId}
                                                                                            currencySymbol={currencySymbol}
                                                                                            transitCityCode={transitCityCode}
                                                                                            transitCityName={transitCityName} // 接收城市
                                                                                            onClickLogistics={(item)=>this.onClickLogistics(item)}
                                                                                            className={"mt_12 logoHalf"} />}
                {/*<LogisticsCompanyList logisticsCompanyList={logisticsCompanyList}*/}
                                      {/*canClick={true}*/}
                                      {/*logisticsCompanyId={logisticsCompanyId}*/}
                                      {/*onClickLogistics={(item)=>this.onClickLogistics(item)}*/}
                                      {/*className={"mt_12 logoHalf"} />*/}


                {/* 使用送货服务 */}
                <div className={`sendCheckBox${sendCheck?" sendCheckBoxOn":""}`} onClick={()=>this.onChangeSend(!sendCheck)}>
                    <p><Checkbox checked={sendCheck}><span className={"black89 fw_700"}>{__getServerLanguage("ShiYongSongHuoFuWu")}</span></Checkbox></p>
                    <p className={"font_14"}>
                        {/*ESSAONE提供免费送车服务，把你的货物送到物流点，可以节省物流公司到仓库的提货路费。如勾选送货服务，则物流发出时间只能选择每周三。*/}
                        {__getServerLanguage("ESSAONETiGongMianFeiSongCheFuWu")}
                    </p>
                </div>

                <FormFormat onRef={this.onRefForm}
                            options={fieldList3}
                            formItemLayout={null}
                            formLayout = "vertical"
                            initialValues={fromInitialValues} />

                {/*商品是否需要打木架？*/}
                <p className={"mt_20 black89 fw_700"}><span className={"color-danger mr_2"}>*</span>{__getServerLanguage("ShangPinShiFouXuYaoDaMuJia")}?</p>
                {/* 根据商品是否易碎打木架，商品体积/重量增加导致物流费用有所增加。 */}
                <p className={"font_14 black45"}>{__getServerLanguage("DaMuJiaTiShi")} </p>
                {/* 需要打木架  易碎商品打木架，将增加费用  MeiGeMuJiaFeiYongTiShi*/}
                {this.renderType("1",packageType,__getServerLanguage("XuYaoDaMuJia"),__getServerLanguage("MeiGeMuJiaFeiYongTiShi"))}
                {/* 全部不需要  因物流货损，自己承担。《货损费用协议》， 点击全部不需要时弹出并选择同意才回显 勾选成功*/}
                {this.renderType("0",packageType,__getServerLanguage("QuanBuBuXuYao"),__getServerLanguage("YinWuLiuHuoSunZiJiChengDan"))}
                <p className={"color-blue cursor-p mt_12"} onClick={()=>this.openAgreement(true)}>{__getServerLanguage("HuoSunFeiYongXieYi")}</p>
            </>}
            {/* 破损自负协议  */}
            {visibleAgreement&&<Modal title={__getServerLanguage("PoSunZiFuXieYi")}
                                      visible={visibleAgreement}
                                      width={660}
                                      footer={null}
                                      onOk={()=>this.handleAgreementOk()}
                                      onCancel={()=>this.openAgreement(false)}>
                {/* 不打木架，运输易碎商品导致损坏，后果自负 */}
                <Alert message={<p><i className={'icon-font icon-waring color-yellow mr_4'} />{__getServerLanguage("DaMuJiaTiShi2")}</p>} type="warning" closable={false}/>
                {/* 破损自负协议内容 */}
                <div className="black89 font_14 mt_10" dangerouslySetInnerHTML={{__html: __getServerLanguage('HuoSunFeiYongXieYiNeiRong')}}></div>
                {visibleAgreementType=="edit"?<div className={"text-right mt_20"}>
                    <Button onClick={()=>this.handleAgreementOk(false)}>{__getServerLanguage('BuTongYi')}</Button>
                    <Button type={'primary'} className={"ml_8"} onClick={()=>this.handleAgreementOk(true)}>{__getServerLanguage('WoTongYi')}</Button>
                </div>:<div className={"text-right mt_20"}>
                    <Button onClick={()=>this.openAgreement(false)}>{__getServerLanguage('GuanBi')}</Button>
                </div>}
            </Modal>}
        </div>);
    }
}

